export default __webpack_public_path__ + "static/media/Destinations.c60a9e8f.png";